if (customElements.get('component-blog-filter') === undefined) {
    class Filters extends HTMLElement {
        constructor() {
            super();
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.initTags();
        }
        initTags() {
            let tags = this.querySelectorAll('.blog-filters_tag');
            let blogs = this.querySelectorAll('article');
            let search = this.querySelector('#search');
            tags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tags.forEach(i => i.classList.remove("selected"));
                    tag.classList.add("selected");
                    const selectedTag = tag.getAttribute('data-value');
                    if (selectedTag != '') {
                        blogs.forEach(blog => {
                            const blogTags = JSON.parse(blog.getAttribute('data-tags')); // Obtener los tags del blog en formato array
                            if (blogTags.includes(selectedTag)) {
                                // Si el blog contiene el tag seleccionado, mostrarlo
                                blog.parentElement.style.display = 'block';
                            }
                            else {
                                // Si no contiene el tag, ocultarlo
                                blog.parentElement.style.display = 'none';
                            }
                        });
                    }
                    else {
                        blogs.forEach(blog => {
                            blog.parentElement.style.display = 'block';
                        });
                    }
                });
            });
            search.addEventListener('input', () => {
                const searchTerm = search.value.toLowerCase();
                blogs.forEach(blog => {
                    let content = blog.querySelector('.c-article_text');
                    const contentText = content.innerHTML.toLowerCase();
                    if (contentText.includes(searchTerm)) {
                        blog.parentElement.style.display = 'block';
                    }
                    else {
                        blog.parentElement.style.display = 'none';
                    }
                });
            });
        }
    }
    customElements.define('component-blog-filter', Filters);
}
